import angular from 'angular';
import controller from './columns.controller';
import template from './columns.html';
import fbtemplate from './builder/preview.html';
import ColumnsComponent from './columns.component';

/**
 * @param {any} $scope
 */
const onEdit = /* @ngInject */ $scope => {
	$scope.removeColumn = (/** @type {number} */ index) => {
		$scope.component.columns.splice(index, 1);
	};
	$scope.addColumn = () => {
		$scope.component.columns.push({
			components: [],
			width:      1,
			offset:     0,
			push:       0,
			pull:       0,
		});
	};
};

const columnsConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('columns', {
		title:      'Columns',
		template,
		group:      'layout',
		selectable: true,
		settings:   new ColumnsComponent(),
		onEdit,
		fbtemplate,
		icon:                       'fa fa-columns',
		noDndOverlay:               true,
		confirmRemove:              true,
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/columns/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller,
	});
};

export default angular.module('app')
	.config(columnsConfig);
